<template>
  <survey-send-invitations
    template-id="OpinionSurvey"
    management-route="opinion-survey"
  />
</template>
<script>
import SurveySendInvitations from "./SurveySendInvitations";

export default {
  name: "OpinionSurveySendInvitations",
  components: { SurveySendInvitations },
};
</script>
